import '../assets/NcFormBox-CRdHJkrd.css';
import { defineComponent, useCssModule, provide, openBlock, createElementBlock, normalizeClass, renderSlot } from "vue";
import { N as NC_FORM_BOX_CONTEXT_KEY } from "./useNcFormBox-Djlh582y.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBox",
  props: {
    row: { type: Boolean }
  },
  setup(__props) {
    const style = useCssModule();
    provide(NC_FORM_BOX_CONTEXT_KEY, {
      isInFormBox: true,
      formBoxItemClass: style.ncFormBox__item
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([_ctx.$style.ncFormBox, _ctx.row ? _ctx.$style.ncFormBox_row : _ctx.$style.ncFormBox_col])
      }, [
        renderSlot(_ctx.$slots, "default", {
          itemClass: _ctx.$style.ncFormBox__item
        })
      ], 2);
    };
  }
});
const ncFormBox = "_ncFormBox_TawZT";
const ncFormBox_row = "_ncFormBox_row_ZnhfS";
const ncFormBox__item = "_ncFormBox__item_7zc34";
const ncFormBox_col = "_ncFormBox_col_wHCZx";
const style0 = {
  "material-design-icon": "_material-design-icon_mubdv",
  ncFormBox,
  ncFormBox_row,
  ncFormBox__item,
  ncFormBox_col
};
const cssModules = {
  "$style": style0
};
const NcFormBox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcFormBox as N
};
//# sourceMappingURL=NcFormBox-wP5mpW88.mjs.map
